export default __webpack_public_path__ + "static/face_5-e418577b7dcefa8cf189d4ab8ce5ef5f.jpg";